<template lang="html">
  <v-form
    class="base-form"
    ref="form"
    :value="value"
    @input="$emit('input', $event)"
    @submit.prevent="validate"
    lazy-validation>
    <slot>
      <v-text-field
        :prepend-icon="icon"
        :label="label"
        :value="textVal"
        class="default-input"
        disabled/>
    </slot>
  </v-form>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      textVal: 'Replace this default input by adding to the fields slot of StandardForm',
      label: 'Example Input',
      icon: ''
    }
  },
  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        this.$emit("submit")
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
